module.exports = "/static/assets/8a062193779ce87c1c79f9ac307ac681.png";